import {Stack} from 'shells/layout/stack/stack';
import {LoadingText} from 'shells/loading-placeholder/loading-text';
import {Body} from 'shells/typography/body';

import type {
    GetLimits_limits as Limits,
    GetAvailablePlans_recurlyAvailablePlans_crm_plans as Plan,
} from 'nutshell-graphql-types';

import {getPlanPill} from './helpers';
import {PlanCard} from './plan-card';

interface Props {
    limits: Limits | null;
    isLoadingPlans: boolean;
    currentPerUser: number;
    upgradePerUser: number;
    upgradePlan: Plan | undefined;
    isHighestPlan: boolean;
}

export function OutOfCreditsAdminContent(props: Props) {
    return (
        <Stack spacing={16}>
            <Body size='xlarge' isBold={true} color='dark'>
                You’re out of AI outcomes
            </Body>
            {props.isLoadingPlans ? (
                <Stack spacing={6}>
                    <LoadingText isFullWidth={true} height={120} />
                </Stack>
            ) : (
                <PlanCard
                    planPill={getPlanPill(props.limits?.currentPlanName ?? '')}
                    label='Current plan'
                    usageText='Your team’s monthly AI outcomes'
                    usageCurrent={props.limits?.currentUsage ?? 0}
                    usageLimit={props.limits?.currentPlanLimit ?? 0}
                    footerText={`${props.currentPerUser.toLocaleString()} outcomes / user / month`}
                />
            )}
            {props.isHighestPlan ? (
                <Body size='small' color='light'>
                    Contact our team if you need more AI outcomes before the end of the month.
                </Body>
            ) : props.isLoadingPlans ? (
                <LoadingText height={250} isFullWidth={true} />
            ) : (
                props.limits?.upgradePlanName &&
                props.limits?.upgradePlanLimit && (
                    <PlanCard
                        planPill={getPlanPill(props.limits?.upgradePlanName ?? '')}
                        label='Recommended'
                        variant='highlighted'
                        usageText='Your team’s monthly AI outcomes'
                        usageCurrent={props.limits?.currentUsage ?? 0}
                        usageLimit={props.limits?.upgradePlanLimit ?? 0}
                        usageLimitColor='highlighted'
                        footerText={`${props.upgradePerUser.toLocaleString()} outcomes / user / month`}
                        bullets={props.upgradePlan?.planHighlights}
                    />
                )
            )}
        </Stack>
    );
}
